import { Button } from 'antd';
import React, { useState } from 'react';

import { useApi } from '../api/useApi';
import { useRouting } from '../routing/routingProvider';
import { store } from '../store';
import { setterGantLoader } from '../store/slices/gantLoaderSlice';
import {
    changeUpdateScheduleFetchKeyWithPolicy,
    changeUpdateTaskFetchKeyWithPolicy,
} from '../store/slices/settingSlice';
import { OnScheduleItemsImport, OnTasksImport, ScheduleItemsImportCallback, TasksImportCallback } from '../types';

interface ControlPanelImportCsvButtonProps {
    onScheduleItemsImport?: OnScheduleItemsImport;
    onTasksImport?: OnTasksImport;
}

export const ControlPanelImportCsvButton: React.FC<ControlPanelImportCsvButtonProps> = ({
    onScheduleItemsImport,
    onTasksImport,
}) => {
    const [inProgress, setInProgress] = useState(false);
    const { schedule } = useApi();

    const { getUrlPath } = useRouting();

    const isItemsPage = getUrlPath().endsWith('items');

    const onClick = async () => {
        setInProgress(true);
        try {
            if (isItemsPage && onScheduleItemsImport) {
                const importScheduleItems: ScheduleItemsImportCallback = async (args) => {
                    await schedule.importScheduleItemsFromCsv(args);

                    store.dispatch(
                        setterGantLoader({ dataScheduleItemFromServer: { rows: [], count: 0, connectionId: '' } }),
                    );
                    store.dispatch(changeUpdateScheduleFetchKeyWithPolicy({ fetchPolicy: 'network-only' }));
                };
                await onScheduleItemsImport(importScheduleItems);
            } else if (onTasksImport) {
                const importTasks: TasksImportCallback = async (args) => {
                    await schedule.importTasksFromCsv(args);

                    store.dispatch(setterGantLoader({ dataTaskFromServer: { rows: [], count: 0, connectionId: '' } }));
                    store.dispatch(changeUpdateTaskFetchKeyWithPolicy({ fetchPolicy: 'network-only' }));
                };
                await onTasksImport(importTasks);
            }
        } finally {
            setInProgress(false);
        }
    };
    return (
        <Button type="link" disabled={inProgress} onClick={onClick}>
            Import from file
        </Button>
    );
};
